angular.module('NaviaqWebApp').directive('orderDeviationLogs', [function () {
    'use strict';

    return {
        restrict: 'E',
        replace: true,
        scope: {
            deviationLogs: '='
        },
        templateUrl: 'app/report/directives/order-deviation-logs.html',
        link: function (scope, element, attrs) {
        }
    };
}]);
